<template>
  <div>
      <Nav></Nav>
      <div class="alge">
    <div class="w">
     <section >
       <div class="maretbar"></div>
       <div class="panter">
        <!-- <a href="javascript:;" >合作案例</a> -->
        <img ref="hovsert" src="../assets/img/anli.png" alt="">
       </div>
      <div class="ss"   @mouseenter="enters" @mouseleave="leavese" >
          <swiper :options="swiperOptions1"  ref="swipe" >
            <swiper-slide v-for="(item,index) in swiperlabel" :key="index">
                <div class="swper_main">
             <img :src="item.img" alt="">

          <div class="swper_right">
            <ul>
              <li v-for="(item,index) in desclist" :key="index">
                 <div class="desc">
              {{item.name}}
             </div>
             <p class="swiping">{{item.desc}}</p>
             <p class="swioings">{{item.diesc_name}}</p>
              <p class="switongs">{{item.exposure}}</p>
              <button >自助注册投放</button>

              <router-link :to="{path:`/case`,query:{cast:JSON.stringify(item)}}"  >查看更多案例</router-link>

             </li>
            </ul>
          </div>
       </div>
           </swiper-slide>
         <div class="swiper-pagination" slot="pagination"></div>

         </swiper>
      </div>

     </section>
  </div>
   <div class="swiper-button-prev ss"  slot="button-prev"></div>
   <div class="swiper-button-next sst" slot="button-next"></div>
</div>
<Footer></Footer>
  </div>
</template>

<script>
import img17 from '../assets/img/mr.png'
import img18 from '../assets/img/sg.png'
import img19 from '../assets/img/hx.png'
import img20 from '../assets/img/sw.png'
// import img21 from '../assets/img/dose2.png'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Nav from '../components/Nav'
import Footer from '../components/Footer'

export default {
  components: {
    swiper,
    swiperSlide,
    Nav,
    Footer
  },
  data () {
    const vm = this
    return {
      desclist: [
        {
          id: 1,
          name: '《明日方舟》',
          desc: '安装包：1.8G',
          diesc_name: '平均成本：80',
          diesc_type: '游戏类型：二次元',
          exposure: '明日方舟推广，利用二次元优质画质，选择精准人群投放，提升用户信任度，加大转化线上超优惠活动引流，戳中用户消费痛点细分人群，多维度覆盖，扩大曝光层级。'

        }
      ],
      swiperOptions1: {
        autoplay: {
          delay: 3000,

          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          transitionEnd: function () {
            const reaindex = this.realIndex

            vm.handleClickSlide(reaindex)
          }
        },
        loop: true,
        // effect: 'flip',
        // fadeEffect: {
        //   slideShadows: true,
        //   limitRotation: true
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperlabel: [
        {
          id: 1,
          img: img17
        },
        {
          id: 2,
          img: img18
        },
        {
          id: 3,
          img: img19
        },
        {
          id: 4,
          img: img20
        }

      ]
    }
  },
  methods: {
    handleClickSlide (index) {
      if (index === 0) {
        this.desclist.forEach((item) => {
          item.name = '《明日方舟》'
          item.desc = '安装包：1.8G'
          item.diesc_name = '平均成本：80'
          item.diesc_type = '游戏类型：二次元'

          item.exposure = '明日方舟推广，利用二次元优质画质，选择精准人群投放，提升用户信任度，加大转化线上超优惠活动引流，戳中用户消费痛点细分人群，多维度覆盖，扩大曝光层级。'
        })
      }
      if (index === 1) {
        this.desclist.forEach((item) => {
          item.name = '《三国志战略版》'
          item.desc = '安装包：922.9M  '
          item.diesc_name = '   平均成本：195'

          item.diesc_type = '游戏类型：SLG'
          item.exposure = '三国志战略版，通过第三方人群包数据，进行人群拓展，优选优质人群包投放，多维度，多地域，多人群覆盖，利用优质话题，提高互动。社交裂变 强势曝光！'
        })
      } else if (index === 2) {
        this.desclist.forEach((item) => {
          item.name = '《三国志幻想大陆》'
          item.desc = '安装包：1.4G'
          item.diesc_name = '平均成本：100'
          item.diesc_type = '游戏类型：卡牌'

          item.exposure = ' 三国志幻想大陆推广，有超高的画质，著名声优配音，明星代言，选择精准人群投放，提升用户信任度，加大转化线上超优惠活动引流，戳中用户消费痛点细分人群，多维度覆盖，扩大曝光层级。'
        })
      } else if (index === 3) {
        this.desclist.forEach((item) => {
          item.name = '《神武4》'
          item.desc = '安装包：1.2G  '
          item.diesc_name = '平均成本：100 '
          item.diesc_type = '   游戏类型：回合制'
          item.exposure = '神武4 游戏推广，加大转化线上超优惠活动引流，根据游戏特点多帮派等进行多维度多人群包选择投放，多维度覆盖人群，扩大曝光层次。'
        })
      } else if (index === 4) {
        // this.desclist.forEach((item) => {
        //   item.exposure = '官场风云推广，提升用户信任度，加大转化线上超优惠活动引流，戳中用户消费痛点细分人群，多维度覆盖，扩大曝光层级'
        // })
      }
    },
    enters () {
      this.$refs.swipe.swiper.autoplay.stop()
    },
    leavese () {
      this.$refs.swipe.swiper.autoplay.start()
    }
  }
}
</script>

<style lang="scss" scoped>
  .alge {
      .ss {
     left: 50px;
      }
      .sst {
        right: 150px;
         outline: none !important;
      }
      .w {
        section {
          .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
            left: 90px;
            width: 100%;
            top: 671px;
            height: 30px;
          }

          // .maretbar {
          //   width: 100%;
          //   border-bottom: 1px solid #EBECED;
          //   position: absolute;
          //   top: 90px;
          // }
          position: relative;
          margin-top: 100px;
            .panter {
            width: 125px;
            height: 29px;
            font-size: 28px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 50px;

            img {
              width: 1200px;
              height: 63px;
            }
            a {
            color: #3F3F40;
            &:hover {
              border-bottom: 5px solid #046AFF;
            }
            }

            }
            .swper_main {
              display: flex;
              margin-top: 114px;
              .swiper-container {
                width: 600px;
                cursor: pointer;
              }
              img {
                width: 627px;
                cursor: pointer;
              }
              .swper_right {
                margin-left: 20px;
                ul {
                  li {
                    margin-top: 110px;
                     .desc {
                width:150px;
                height: 20px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333333;
                line-height: 19px;
                margin-bottom: 40px;
                margin-top: 20px;
              }
              .swiping {
                width: 164px;
                height: 18px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                line-height: 19px;
              }
              .swioings {
                width: 362px;
              height: 45px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 26px;
              margin-top: 41px;
              }
              .switongs {
                width: 359px;
                height: 43px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                line-height: 26px;
                margin-top: 41px;
              }
              button {
                margin-top: 86px;
                width: 204px;
                height: 56px;
                background: linear-gradient(-4deg, rgba(0, 93, 255, 0.84), rgba(4, 190, 253, 0.84));
                box-shadow: 0px 5px 17px 1px rgba(62, 116, 147, 0.35);
                border-radius: 4px;
                color: #fff;
                cursor: pointer;
              }
              .radius {
                margin-top: 71px;
              }
              a {
                display: block;
                width: 124px;
                height: 16px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #0696FE;
                line-height: 26px;
                margin-top:120px;
                cursor: pointer;
              }
                  }
                }

              }
            }
            .fotoe {
              position: absolute;
             width: 100%;
             top: 748px;
             left: 46px;
              height: 440px;
              background-color: pink;
              z-index: 33;
            }
        }
    }
   }
</style>
